enum LeftNavRoutesEnumSh {
  DASHBOARD_MANAGEMENT = '/stubhub/dashboard/management',
  DASHBOARD_OPERATIONS = '/stubhub/dashboard/operations',
  DASHBOARD_BOT_PERFORMANCE = '/stubhub/dashboard/bot-performance',
  DASHBOARD_FINANCE = '/stubhub/dashboard/finance',
  DASHBOARD_BROKER = '/stubhub/dashboard/broker',
  DASHBOARD_LISTER = '/stubhub/dashboard/lister',
  DASHBOARD_BUYER = '/stubhub/dashboard/buyer',
  DASHBOARD_CHECKER = '/stubhub/dashboard/checker',
  DASHBOARD_SEATMAPCREATOR = '/stubhub/dashboard/seat-map-creator',
  DASHBOARD_PERFORMANCE_ANALYSIS = '/stubhub/dashboard/performance-analysis',
  //Zones
  ZONES_LISTING = '/stubhub/zones/zone-listings',
  ZONES_LISTING_EDIT_EVENT_AVAILABILITY = '/stubhub/zones/zone-listings/edit-event-metadata',
  ZONE_LISTINGS_ACTIVE_LISTINGS = '/stubhub/zones/zone-listings/active-listings',
  ZONES_PENDING_FILLS = '/stubhub/zones/pending-fills',
  ZONES_INSIGHTS = '/stubhub/zones/insights',
  //Housekeeping
  HOUSEKEEPING_CANCELLED_SHOWS = '/stubhub/housekeeping/cancelled-shows',
  HOUSEKEEPING_CANCELLED_SHOWS_ACTIVE = '/stubhub/housekeeping/cancelled-shows/active',
  HOUSEKEEPING_CANCELLED_SHOWS_SOLD = '/stubhub/housekeeping/cancelled-shows/sold',
  HOUSEKEEPING_CANCELLED_SHOWS_UNFILLED = '/stubhub/housekeeping/cancelled-shows/unfilled',
  HOUSEKEEPING_CANCELLED_SHOWS_CANCELLED = '/stubhub/housekeeping/cancelled-shows/cancelled',
  HOUSEKEEPING_EVENT_MAPPING = '/stubhub/housekeeping/event-mapping',
  //Trading
  TRADING_VENUES = '/stubhub/trading/venues',
  TRADING_EVENTS = '/stubhub/trading/events',
  TRADING_EVENTS_CREATE_NEW_ZONE_LISTING = '/stubhub/trading/events/create-new-zone-listing',
  TRADING_EVENTS_CREATE_NEW_ZONE_LISTING_BULK_PLACEMENT = '/stubhub/trading/events/create-new-zone-listing/bulk-placement',
  TRADING_EVENTS_CREATE_NEW_ZONE_LISTING_WITHOUT_METADATA = '/stubhub/trading/events/create-new-zone-listing-without-metadata',
  INSIGHTS_REPORTS = '/stubhub/insights/reports',
  INSIGHTS_SCHEDULES = '/stubhub/insights/schedules',
  MESSAGES_INBOX = '/stubhub/messages/inbox',
  MESSAGES_ARCHIVES = '/stubhub/messages/archives',
  MESSAGES_SENT = '/stubhub/messages/sent',
  //Purchases
  PURCHASE_QUEUE = '/stubhub/purchases/purchase-queue',
  //Shipping
  SHIPPING_QUEUE = '/stubhub/shipping/shipping-queue',
  DELIVERED_TICKETS_REPORT = '/stubhub/shipping/delivered-tickets',
}

enum ReportRoutesEnumSh {
  GROSS_PROFIT_REPORT = '/stubhub/reports/profit-gross',
  PROFIT_DASHBOARD_REPORT = '/stubhub/reports/profit-dashboard',
  LONG_INVENTORY_REPORT = '/stubhub/reports/inventory-long',
  LONG_INVENTORY_NOT_LISTED_REPORT = '/stubhub/reports/inventory-long-not-listed',
  LONG_INVENTORY_SCORECARD_REPORT = '/stubhub/reports/long-inventory-scorecard-broker',
  BROKER_TAG_ISSUES_REPORT = '/stubhub/reports/broker-tags-issues',
  CONSIGNMENT_SALES_REPORT = '/stubhub/reports/consignment-sales',
  SHORTS_PENDING_DELIVERY_REPORT = '/stubhub/reports/orders-pending-delivery',
  GROSS_PROFIT_CANCELLED_REPORT = '/stubhub/reports/gross-profit-cancelled',
  CONSIGNMENT_PENDING_BUY_IN_REPORT = '/stubhub/reports/consignment-pending-buy-in',
  INVOICES_NEEDING_ATTENTION = '/stubhub/reports/invoices-needing-attention',
  RECEIVABLES_DETAILS = '/stubhub/reports/receivables-wholesale-consignments',
  RECEIVABLES_RETAIL = '/stubhub/reports/receivables-retail',
  RECEIVABLES_DETAILS_OLD = '/stubhub/reports/receivables-wholesale-consignments-old',
  RECEIVABLES_RETAIL_OLD = '/stubhub/reports/receivables-retail-old',
  ACTIVE_ZONE_LISTING_REPORT = '/stubhub/reports/active-zone-listing-report',
  OTHER_COSTS_AND_CREDITS = '/stubhub/reports/other-costs-and-credits-report',
}

enum LeftNavMenuKeysEnumSh {
  DASHBOARD = '/dashboard',
  ZONES = '/zones',
  TRADING = '/trading',
  PURCHASES = '/purchases',
  SHIPPING = '/shipping',
  HOUSEKEEPING = '/housekeeping',
  INSIGHTS = '/insights',
  MESSAGES = '/messages',
}

export { LeftNavRoutesEnumSh, LeftNavMenuKeysEnumSh, ReportRoutesEnumSh };
